import React from 'react';
import {
  withStyles,
  Dialog,
  Button,
  DialogActions,
  DialogTitle,
  DialogContent,
  DialogContentText
} from '@material-ui/core';

const styles = theme => ({
  paper: {
    borderRadius: 0
  },
  buttonWrapper: {
    padding: theme.spacing(2, 3),
    borderTop: '1px solid #E1E1E1'
  },
  contentWrapper: {
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3)
  },
  continueButton: {
    color: theme.palette.secondary.main,
    textTransform: 'none',
    width: theme.spacing(10)
  },
  closeButton: {
    color: '#919191',
    textTransform: 'none',
    border: '1px solid #919191',
    width: theme.spacing(10)
  },
  titleWrapper: {
    borderBottom: '1px solid #E1E1E1'
  }
});

function ApiKeyConfirmationPopup(props) {
  const { showApiConfirmationPopup, handleContinue, handleClose, classes, isApiKeyAvailable } = props;

  const getContentText = () => {
    if (isApiKeyAvailable) {
      return 'New API Key will disable all connections made with current API key. Do you still want to generate a new API Key ?';
    }
    return 'Make sure you keep this secure, this token gives full accesss to your account.';
  };

  return (
    <div>
      <Dialog open={showApiConfirmationPopup} onClose={handleClose} classes={{ paper: classes.paper }}>
        <DialogTitle className={classes.titleWrapper}>{'Confirmation'}</DialogTitle>
        <DialogContent className={classes.contentWrapper}>
          <DialogContentText>{getContentText()}</DialogContentText>
        </DialogContent>
        <DialogActions className={classes.buttonWrapper}>
          <Button onClick={() => handleClose()} className={classes.closeButton}>
            Close
          </Button>
          <Button
            onClick={() => handleContinue()}
            color="primary"
            variant="contained"
            className={classes.continueButton}
          >
            {isApiKeyAvailable ? 'Proceed' : 'Continue'}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default withStyles(styles)(ApiKeyConfirmationPopup);
